import { Link } from "react-router-dom";
import { siteStats } from "@/mocks/news";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { usePageMeta } from "@/hooks/usePageMeta";

const values = [
  { icon: "ri-shield-check-line", title: "权威可信", desc: "坚持多方核实与信息溯源，标注内容来源，让每一条爆料都经得起推敲。" },
  { icon: "ri-flashlight-line", title: "及时迅捷", desc: "7×24 小时编辑值守，突发事件第一时间跟进，动态更新事件进展。" },
  { icon: "ri-focus-3-line", title: "客观中立", desc: "呈现多方声音，区分事实与观点，避免情绪化表达与片面判断。" },
  { icon: "ri-user-heart-line", title: "贴近民生", desc: "聚焦与普通人生活息息相关的社会热点，让新闻回到生活本身。" },
];

const services = [
  { icon: "ri-newspaper-line", title: "爆料资讯", desc: "聚合社会、娱乐、财经、科技等八大领域的最新爆料与热点新闻。" },
  { icon: "ri-filter-3-line", title: "多维筛选", desc: "按时间、类型、地区组合筛选，支持热度与评论数排序，快速定位内容。" },
  { icon: "ri-search-eye-line", title: "全站搜索", desc: "关键词全文检索，标题、摘要与标签全覆盖，结果实时呈现。" },
  { icon: "ri-file-paper-2-line", title: "深度报道", desc: "图文与视频结合，还原事件脉络，提供前因后果的完整解读。" },
];

export default function AboutPage() {
  usePageMeta({
    title: "关于我们 - 51爆料网",
    description:
      "51爆料网以权威、及时、真实为准则，介绍平台定位、运营理念与服务内容，并提供免责声明与隐私保护说明。",
    keywords: "51爆料网,关于我们,平台介绍,运营理念,免责声明,隐私保护",
  });

  return (
    <div className="w-full">
      <div className="border-b border-background-200 bg-background-100">
        <div className="mx-auto max-w-[1280px] px-4 py-5 md:px-6 md:py-6">
          <Breadcrumb items={[{ label: "关于我们" }]} />
          <h1 className="mt-4 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
            关于 51爆料网
          </h1>
          <p className="mt-2 max-w-3xl text-sm text-foreground-500">
            权威且实时的社会爆料与热点新闻平台，帮助你第一时间掌握真实信息。
          </p>
        </div>
      </div>

      <div className="mx-auto max-w-[1280px] px-4 py-10 md:px-6 md:py-12">
        <section className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
          <div>
            <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">网站定位</h2>
            <p className="mt-4 text-sm leading-8 text-foreground-600">
              51爆料网定位为<strong className="text-foreground-900">权威且实时的社会爆料与热点新闻平台</strong>。
              我们面向关心社会动态、需要第一时间获取真实爆料与深度报道的普通网民、新闻爱好者与社会观察者，
              以清晰的信息层级与舒适的阅读体验，让复杂的新闻变得易于理解。
            </p>
            <p className="mt-4 text-sm leading-8 text-foreground-600">
              从城市治理到民生日常，从科技前沿到文娱动态，我们持续追踪每一个正在发生的故事，
              力求做到内容客观、更新及时、检索便捷。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/category/all"
                className="flex items-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                <i className="ri-apps-2-line" />
                浏览全部爆料
              </Link>
              <Link
                to="/contact"
                className="flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-5 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
              >
                <i className="ri-customer-service-2-line" />
                联系我们
              </Link>
            </div>
          </div>
          <div className="h-[260px] w-full overflow-hidden rounded-lg bg-background-200 md:h-[340px]">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20professional%20newsroom%20with%20editors%20working%20on%20large%20screens%2C%20clean%20bright%20interior%2C%20editorial%20photography%2C%20soft%20natural%20light%2C%20high%20detail&width=1200&height=800&seq=about-mission-01&orientation=landscape"
              alt="51爆料网编辑团队工作场景"
              title="51爆料网 内容团队"
              className="h-full w-full object-cover object-top"
            />
          </div>
        </section>

        <section className="mt-14">
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">运营理念</h2>
          <p className="mt-2 text-sm text-foreground-500">四条准则，贯穿每一条内容的采编与呈现。</p>
          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {values.map((v) => (
              <div key={v.title} className="rounded-lg border border-background-200 bg-background-50 p-5">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-primary-100 text-primary-600">
                  <i className={`${v.icon} text-2xl`} />
                </span>
                <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{v.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-500">{v.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-14">
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">服务内容</h2>
          <p className="mt-2 text-sm text-foreground-500">围绕“获取信息”这件事，我们持续打磨每一个环节。</p>
          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2">
            {services.map((s) => (
              <div
                key={s.title}
                className="flex gap-4 rounded-lg border border-background-200 bg-background-100 p-5"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-accent-100 text-accent-600">
                  <i className={`${s.icon} text-2xl`} />
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-950">{s.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-foreground-500">{s.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="mt-14 grid grid-cols-2 gap-4 rounded-lg bg-primary-950 p-6 sm:grid-cols-4 md:p-8">
          {siteStats.map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="font-label text-2xl font-extrabold text-accent-400 md:text-3xl">{stat.value}</p>
              <p className="mt-1 text-xs text-primary-200 md:text-sm">{stat.label}</p>
            </div>
          ))}
        </section>

        <section className="mt-14 grid grid-cols-1 gap-4 lg:grid-cols-2">
          <div className="rounded-lg border border-background-200 bg-background-50 p-6">
            <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                <i className="ri-error-warning-line" />
              </span>
              免责声明
            </h2>
            <ul className="mt-4 space-y-3 text-sm leading-relaxed text-foreground-600">
              <li>本站所展示内容中，标注为演示的部分仅为功能展示，不代表真实事件或观点。</li>
              <li>用户提供的爆料线索按原意整理，若涉及事实争议，以相关部门调查结论为准。</li>
              <li>如内容涉及版权、名誉权等问题，请通过联系我们页提交反馈，我们将及时处理。</li>
            </ul>
          </div>
          <div className="rounded-lg border border-background-200 bg-background-50 p-6">
            <h2 className="flex items-center gap-2 font-heading text-lg font-bold text-foreground-950">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                <i className="ri-lock-2-line" />
              </span>
              隐私保护说明
            </h2>
            <ul className="mt-4 space-y-3 text-sm leading-relaxed text-foreground-600">
              <li>我们仅收集为你提供服务所必需的信息，例如你在反馈表单中主动填写的联系方式。</li>
              <li>未经你的同意，我们不会将个人信息用于服务之外的用途或对外提供。</li>
              <li>对于匿名爆料，我们承诺严格保护线索来源，保障爆料人安全。</li>
            </ul>
          </div>
        </section>
      </div>
    </div>
  );
}